module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row no-gutters",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 form-group",
    class: {
      'has-error': this.validation && this.validation.$error
    }
  }, [_c('div', {
    staticClass: "input-group password-input"
  }, [_c('float-label', {
    attrs: {
      "label": _vm.required ? _vm.label + '*' : _vm.label
    }
  }, [(_vm.passwordNotVisible) ? _c('input', {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "id": _vm.name,
      "name": "password*",
      "placeholder": _vm.required ? _vm.label + '*' : _vm.label
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": _vm.blur
    }
  }) : _c('input', {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": _vm.name,
      "name": _vm.name,
      "placeholder": _vm.required ? _vm.label + '*' : _vm.label
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": _vm.blur
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    on: {
      "click": _vm.showHidePassword
    }
  }, [(_vm.passwordNotVisible) ? _c('i', {
    staticClass: "glyphicon glyphicon-eye-close"
  }) : _c('i', {
    staticClass: "glyphicon glyphicon-eye-open"
  })])], 1), _vm._v(" "), (_vm.validation && _vm.validation.$error) ? _c('div', {
    staticClass: "col-xs-12 help-block small",
    attrs: {
      "role": "alert"
    }
  }, [(_vm.requiredError) ? _c('span', [_vm._v("The field is required")]) : (_vm.passwordError) ? _c('span', [_vm._v("Password needs at least 8 characters. Must consist of at least one number character and one alphabet character")]) : (_vm.passwordMatchError) ? _c('span', [_vm._v("The value entered does not match")]) : _c('span', [_vm._v("Please enter a valid value for this field")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fe23746"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/inputs/InputPassword.vue
// module id = 656
// module chunks = 5